import { State } from '../redux-state';
import { authenticatedGetJson, authenticatedPostJson } from '../utils/requests';
import {
    MANAGER_NOTES_ANSWER_ERROR,
    MANAGER_NOTES_ANSWER_SUCCESS,
    MANAGER_NOTES_FETCH_ERROR,
    MANAGER_NOTES_FETCH_LOADING,
    MANAGER_NOTES_FETCH_SUCCESS,
    ManagerNotesAnswerError,
    ManagerNotesAnswerSuccess,
    ManagerNotesFetchError,
    ManagerNotesFetchLoading,
    ManagerNotesFetchSuccess,
} from './managerNotesTypes';
import { Action } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';

const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

const managerNotesFetchSuccess = (data: any): ManagerNotesFetchSuccess => ({
    type: MANAGER_NOTES_FETCH_SUCCESS,
    payload: data,
});

const managerNotesFetchError = (error: Error): ManagerNotesFetchError => ({
    type: MANAGER_NOTES_FETCH_ERROR,
    error: true,
    payload: { error, firstTimeLoading: false },
});

const setManagerNotesFetchLoading = (loading: boolean): ManagerNotesFetchLoading => ({
    type: MANAGER_NOTES_FETCH_LOADING,
    // Clear stale answers when a new fetch starts so a previously loaded
    // reportee's notes are not shown while the new ones are loading.
    payload: loading ? { loading, answers: [] } : { loading },
});

const managerNotesAnswerSuccess = (): ManagerNotesAnswerSuccess => ({
    type: MANAGER_NOTES_ANSWER_SUCCESS,
    payload: {},
});

const managerNotesAnswerError = (error: Error): ManagerNotesAnswerError => ({
    type: MANAGER_NOTES_ANSWER_ERROR,
    error: true,
    payload: { error },
});

const getManagerNotes = (
    surveyId: any,
    uid: any,
    managerUid: string,
): ThunkAction<void, State, null, Action> => {
    return async (dispatch: ThunkDispatch<State, null, Action<any>>): Promise<any> => {
        dispatch(setManagerNotesFetchLoading(true));
        try {
            const resp = await authenticatedGetJson(
                `${backendUrl}/manager_notes?managerUid=${managerUid}`,
                surveyId,
                uid,
            );
            if (resp === 401) return;
            dispatch(managerNotesFetchSuccess(resp));
        } catch (err) {
            dispatch(managerNotesFetchError(err as Error));
        }
        dispatch(setManagerNotesFetchLoading(false));
    };
};

const submitManagerNotes = (
    answers: Array<any>,
    surveyId: any,
    uid: any,
    managerUid: string,
): ThunkAction<void, State, null, Action> => {
    return async (dispatch: ThunkDispatch<State, null, Action<any>>): Promise<any> => {
        try {
            await authenticatedPostJson(
                `${backendUrl}/manager_notes`,
                surveyId,
                { managerUid, answers },
                uid,
            );
            dispatch(managerNotesAnswerSuccess());
            dispatch(getManagerNotes(surveyId, uid, managerUid));
        } catch (err) {
            dispatch(managerNotesAnswerError(err as Error));
        }
    };
};

export { getManagerNotes, submitManagerNotes };
